
export function collectUniqueValues<T>(
  items: T[],
  selector: (item: T) => (string | null | undefined)[]
): string[]  {
  const map = new Map<string, string>();

  for (const item of items) {
    const vals = selector(item);
    for (const value of vals) {
      if (!value) continue;
      const lower = value.toLowerCase();
      if (lower === "нет") continue;
      if (!map.has(lower)) map.set(lower, value);
    }
  }

  return Array.from(map.values());
}

const SUPER_TYPE_DISPLAY_MAP: Record<string, string> = {
  "Керамика": "Раковины, унитазы, биде",
};

export const getCatalogTypeDisplayName = (type?: string | null): string => {
  if (!type) return "";
  return SUPER_TYPE_DISPLAY_MAP[type] ?? type;
};

const CATALOG_TYPE_SORT_ORDER = [
  "Смесители",
  "Системы слива",
  "Аксессуары",
  "Керамика",
  "Инсталляции",
  "Ограждения",
] as const;

export const sortCatalogTypes = <T extends { type: string }>(items: T[]): T[] => {
  const orderMap = new Map(CATALOG_TYPE_SORT_ORDER.map((type, index) => [type, index]));

  return [...items].sort((a, b) => {
    const indexA = orderMap.get(a.type) ?? Number.POSITIVE_INFINITY;
    const indexB = orderMap.get(b.type) ?? Number.POSITIVE_INFINITY;

    if (indexA !== indexB) {
      return indexA - indexB;
    }

    return a.type.localeCompare(b.type, "ru");
  });
};

export const decodeDeep = (value: string): string => {
  let prev = value;
  for (let i = 0; i < 3; i++) {
    try {
      const next = decodeURIComponent(prev);
      if (next === prev) return next;
      prev = next;
    } catch {
      return prev;
    }
  }
  return prev;
};
